export default function MobileHeader(
	header,
	allMenus,
	closeAll,
	toggleMenu,
	hamburger,
	scrollHeader
) {
	this.mainHeader = header;
	this.allMenus = allMenus;
	this.closeAll = closeAll;
	this.toggleMenu = toggleMenu;
	this.hamburger = hamburger;
	this.scrollHeader = scrollHeader;

	this.mobileMenu = this.mainHeader.querySelector('.main-header__mobile');
	this.mobileBackTriggers = this.mobileMenu.querySelectorAll('.mega-menu-wrapper__back-button');
	this.menuTriggers = this.mobileMenu.querySelectorAll(
		'.mobile-menu .menu-item'
	);

	this.toggleMobileBack = (e) => {
		const btnLinkCheck =
			e.target.tagName === 'BUTTON' || e.target.tagName === 'A';
		const trigger = btnLinkCheck ? e.target : e.target.parentElement;

		trigger.parentElement.parentElement.classList.remove('active');
		trigger.parentElement.parentElement.parentElement.classList.remove('active');
		trigger.parentElement.parentElement.previousElementSibling.classList.remove('active');
		this.scrollHeader.classList.remove('active');
		this.hamburger.classList.remove('sub-open');
	}

	this.mobileBackEvents = () => {
		this.mobileBackTriggers.forEach((backTrigger) => {
			backTrigger.addEventListener('click', (e) => {
				this.toggleMobileBack(e);
			});
		});
	}

	this.hamburgerEvents = () => {
		this.hamburger.addEventListener('click', (e) => {
			this.toggleMenu(e);
		});
	};

	this.menuEvents = () => {
		this.menuTriggers.forEach((parent) => {
			parent.addEventListener('click', (e) => {
				this.toggleMenu(e);
			});
		});
	};

	this.events = () => {
		this.hamburgerEvents();
		this.menuEvents();
		this.mobileBackEvents();
	};

	return this;
}
